import { Alert, AlertTitle } from '@mui/material';
import { ErrorBoundaryProps, ErrorBoundaryState } from 'models';
import React from 'react';

class ErrorBoundary extends React.Component<
	ErrorBoundaryProps,
	ErrorBoundaryState
> {
	constructor(props: ErrorBoundaryProps) {
		super(props);
		this.state = { error: null };
	}

	static getDerivedStateFromError(error: Error) {
		// Update state so the next render will show the fallback UI.
		return { error };
	}

	componentDidCatch(error: Error, info: React.ErrorInfo) {
		// Log the error for monitoring — do NOT call setState here,
		// getDerivedStateFromError already handles state and triggers the fallback render.
		console.error('ErrorBoundary caught:', { error, info });
	}

	render() {
		if (this.state.error) {
			return (
				<div style={{ padding: '20px' }}>
					<Alert severity="error">
						<AlertTitle>Something went wrong.</AlertTitle>
						{this.state.error.toString()}
					</Alert>
				</div>
			);
		}

		return this.props.children;
	}
}

export default ErrorBoundary;
